<template>
  <div class="history">
    <v-btn
      @click="showHistory = !showHistory"
      class="btn-blue"
      color="yellow"
    >
      <span>История</span>
      <v-icon>{{ showHistory ? "mdi-chevron-down" : "mdi-chevron-up" }}</v-icon>
    </v-btn>
    <v-expand-transition>
      <div v-if="!showHistory" class="history-container">
        <div v-for="h in history" :key="h.id">
          🕑{{ h.created_at }} - {{ h.note }}
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'History',
  props: ['history'],
  data() {
    return {
      // Показать/скрыть историю
      showHistory: true,
    };
  },
};
</script>

<style scoped lang="scss">
.history {
  display: flex;
  flex-direction: column;
  align-items: flex-end;


  @media (max-width: 1299px) {
    align-items: flex-start;
    margin-top: 30px;
  }

  @media (max-width: 767px) {
    margin-top: 0;
  }

  .v-btn {
    min-width: 245px!important;

    @media (max-width: 767px) {
      min-width: 50%!important;
      align-self: center;
    }
    @media (max-width: 499px) {
      width: 100%;
    }
  }
}

.history-container {
  margin-top: 10px;
  li {
    list-style-type: none;
  }
}
</style>
